module.exports = __webpack_public_path__ + "img/bg15.2ee31100.png";